import { Button } from '@eventbrite/eds-button';
import { Modal } from '@eventbrite/eds-modal';
import { getOldOrNewFeature } from '@eventbrite/marketing-tools-common';
import React, { useEffect, useState } from 'react';
import {
    reloadOnCloseSecondStep,
    trackOnClose,
} from '../constants/ActivationTrialModal';
import './ActivationModal.scss';
import { TrialFlow } from './TrialFlow';
import { ActivationTrialModalProps, TrialFlowProps } from './types';

export const ActivationTrialModal: React.FC<
    ActivationTrialModalProps & TrialFlowProps
> = ({
    openModal,
    onCloseModal,
    showButton,
    buttonStyle,
    buttonContainerClassName,
    buttonText,
    setOpenBoostSubscriptionModal,
    ...trialFlowProps
}) => {
    const [isOpen, setIsOpen] = useState<boolean>(openModal);
    const [showSecondStep, setShowSecondStep] = useState<boolean>(false);

    useEffect(() => {
        setIsOpen(openModal);
    }, [openModal]);

    const closeModal = (showSecondStep: boolean) => {
        onCloseModal?.();
        trackOnClose(showSecondStep);
        setIsOpen(false);
        reloadOnCloseSecondStep(showSecondStep);
        setOpenBoostSubscriptionModal?.(false);
    };
    const handleOpenModal = () => {
        setIsOpen(true);
    };

    // BoostRebrand.
    const modal = (
        <>
            {showButton && (
                <Button
                    style={buttonStyle}
                    onClick={() => handleOpenModal()}
                    id="open-modal-button"
                    __containerClassName={buttonContainerClassName}
                >
                    {buttonText}
                </Button>
            )}
            <div
                className={
                    'boost-activation-modal ' +
                    (trialFlowProps.trialVersion || '')
                }
            >
                <Modal
                    isShown={isOpen}
                    onClose={() => closeModal?.(showSecondStep)}
                    disableCloseOnClickOutside
                    noPadding
                >
                    <TrialFlow
                        onCloseModal={closeModal}
                        setShowSecondStep={setShowSecondStep}
                        {...trialFlowProps}
                    />
                </Modal>
            </div>
        </>
    );

    // BoostRebrand. Hides Boost Activation Modal from users of new subscription service
    const activationTrialModal = getOldOrNewFeature(modal);

    return activationTrialModal;
};

ActivationTrialModal.defaultProps = {
    buttonText: 'Start your free trial',
    buttonStyle: 'fill',
    openModal: false,
    showButton: true,
} as Partial<ActivationTrialModalProps>;
